// import {
//     Button,
//     Divider,
//     Form,
//     Input,
//     message,
//     Space,
//     Tag,
//     Typography,
//     Modal
//   } from "antd";
//   import { ArrowLeftOutlined } from '@ant-design/icons';
//   import React, { useState, useRef, useEffect } from "react";
//   import LoadingSpin from "../../../loadingSpin/LoadingSpin";
//   import { useLocation, useNavigate } from "react-router";
// import ResponseMessage from "../../../Comman/Notification/ResponseMessge";
  
//   const { Title, Text } = Typography;
  
//   const AddKanban = ({ userData }) => {
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [scannedData, setScannedData] = useState("");
//     const [isLoading, setIsLoading] = useState(false);
//     const [isModalVisible, setIsModalVisible] = useState(false);
//     const [scannedValue, setScannedValue] = useState("");
//     const [startScan, setStartScan] = useState(false);
//     const [binId, setBinId] = useState();

//     const scannerRef = useRef(null);
//     const navigate = useNavigate();
//     const [form] = Form.useForm();
//     const location = useLocation();

//     useEffect(() => {
//       const queryParams = new URLSearchParams(location.search);
//       setBinId(queryParams.get('bin_id'));
      
//     }, [location.search]);
  
//     const handleTagClick = () => {
//       console.log('Scan barcode');
//     };
  
//     const handleArrowClick =()=>{
//       navigate(`/manage-bin`)
//     };
//     const onFinish = async (values) => {
//       try {
//         const dataToSubmit = values.kb_number || values;
//         setScannedData(dataToSubmit);
  
//         if (!dataToSubmit) {
//           ResponseMessage.error({ message : "Please provide valid scanned data or enter it manually"});
//           return;
//         }
  
//         setIsSubmitted(true);
//         setIsLoading(true);

//         navigate(`/manage-bin/view/add-garment?bin_id=${encodeURIComponent(binId)}&kb_num=${encodeURIComponent(dataToSubmit)}`);
  
//       } catch (error) {
//         console.error('Error:', error);
//         setIsLoading(false);
//         ResponseMessage.error({ message : "An error occurred while fetching data."});
//         setIsSubmitted(false);
//       }
//     };
  
//     return (
//       <div>
//         <Title level={5} style={{ marginTop: -15, margin: 0 }}>
//             <>
//                 <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
//                 Add Garment
//             </>
//         </Title>
  
//         <Divider style={{ marginTop: 8 }} />
  
//         {/* {!isSubmitted ? ( */}
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <Tag
//               style={{
//                 width: "300px",
//                 height: "90px",
//                 color: "#2db7f5",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 backgroundColor: "#2db7f5",
//                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
//                 borderRadius: "10px",
//               }}
//               color="#2db7f5"
//               onClick={handleTagClick}
//             >
//               <Text strong style={{ fontSize: "20px", color: "white", fontWeight: "bold" }}>
//                 SCAN HERE
//               </Text>
//             </Tag>
  
//             <Space block size="large" style={{ padding: "20px 0" }}>
//               <Text strong>OR</Text>
//             </Space>
  
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%" }}>
//               <Form
//                 name="form_item_path"
//                 layout="vertical"
//                 onFinish={onFinish}
//                 form={form}
//                 style={{ width: "300px" }}
//               >
//                 <Form.Item name="kb_number" label="Enter Manually"
//                 rules={[
//                     {
//                         required: true,
//                         message: "ID cannot be empty. Please provide a valid ID."
//                     }
//                 ]}>
//                   <Input autoFocus size="large" style={{ width: "100%", textAlign: "center" }} />
//                 </Form.Item>
  
//                 <Form.Item>
//                   <div style={{ display: "flex", justifyContent: "center" }}>
//                     <Button type="primary" htmlType="submit">
//                       Submit
//                     </Button>
//                   </div>
//                 </Form.Item>
//               </Form>
//             </div>
//           </div>
//         {/* ) : isLoading ? (
//           <LoadingSpin />
//         ) :  null
//         }
//    */}
//         <Modal
//           destroyOnClose={true}
//           visible={isModalVisible}
//           onCancel={() => {
//             setIsModalVisible(false);
//             setStartScan(false);
//           }}
//           footer={null}
//           style={{ top: 20, display: "flex", justifyContent: "center" }}
//         >
//         </Modal>
//       </div>
//     );
//   };
  
//   export default AddKanban;
  

import {
  Button,
  Divider,
  Form,
  Input,
  Space,
  Typography,
  Card,
  Modal,
} from "antd";
import { ArrowLeftOutlined, ScanOutlined, EditOutlined } from "@ant-design/icons";
import React, { useState, useRef, useEffect } from "react";
import LoadingSpin from "../../../loadingSpin/LoadingSpin";
import { useLocation, useNavigate } from "react-router";
import ResponseMessage from "../../../Comman/Notification/ResponseMessge";

const { Title, Text } = Typography;

const AddKanban = ({ userData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startScan, setStartScan] = useState(false);
  const [binId, setBinId] = useState();

  const scannerRef = useRef(null);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setBinId(queryParams.get("bin_id"));
  }, [location.search]);

  const handleTagClick = () => {
    setIsModalVisible(true);
    setStartScan(true);
  };

  const handleArrowClick = () => {
    navigate(`/manage-bin`);
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = values?.kb_number || values;

      if (!dataToSubmit) {
        ResponseMessage.error({
          message: "Please provide valid scanned data or enter it manually",
        });
        return;
      }

      setIsSubmitted(true);
      setIsLoading(true);

      navigate(
        `/manage-bin/view/add-garment?bin_id=${encodeURIComponent(
          binId
        )}&kb_num=${encodeURIComponent(dataToSubmit)}`
      );
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      ResponseMessage.error({
        message: "An error occurred while fetching data.",
      });
      setIsSubmitted(false);
    }
  };

  return (
    <div className="page-container">
      
      {/* 🔹 Header */}
      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              onClick={handleArrowClick}
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            Add Garment
          </Title>
          <Text className="page-subtitle">
            Scan or enter Kanban to add garment into bin
          </Text>
        </div>
      </div>

      <Divider className="page-divider" />

      {/* 🔹 Main Card */}
      <Card className="modern-card" title="Scan / Enter Kanban">
        
        <div style={{ maxWidth: 400, margin: "0 auto" }}>
          
          {/* 🔹 Scan Card */}
          <div
            className="dashboard-stat-card bg-card-blue"
            style={{ textAlign: "center" }}
            onClick={handleTagClick}
          >
            <div className="dashboard-stat-card-inner">
              <ScanOutlined style={{ fontSize: 32, color: "#1e3a8a" }} />
              <div className="dashboard-stat-title">SCAN HERE</div>
              <Text style={{ fontSize: 12, color: "#475569" }}>
                Tap to scan qrcode
              </Text>
            </div>
          </div>

          <Space
            style={{
              margin: "20px 0",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Text strong>OR</Text>
          </Space>

          {/* 🔹 Manual Entry */}
          <Form layout="vertical" onFinish={onFinish} form={form}>
            <Form.Item
              name="kb_number"
              label="Enter Manually"
              rules={[
                {
                  required: true,
                  message: "ID cannot be empty. Please provide a valid ID.",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter Kanban Number"
                style={{ textAlign: "center" }}
                prefix={<EditOutlined />}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="primary-btn"
                size="large"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Card>

      {/* 🔹 Scanner Modal */}
      <Modal
        destroyOnClose
        open={isModalVisible}   // ✅ FIXED (was visible)
        onCancel={() => {
          setIsModalVisible(false);
          setStartScan(false);
        }}
        footer={null}
        centered
      >
        {/* Add ScanBarCode component here if needed */}
      </Modal>

      {/* 🔹 Loader */}
      {isLoading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}
    </div>
  );
};

export default AddKanban;